/**
 * Uses AutoEncoder metadata or a container-specific discriminator to distinguish patches from puts.
 */
export class PatchOrPutDecoder {
    putDecoder;
    patchDecoder;
    constructor(put, patch) {
        this.putDecoder = put;
        this.patchDecoder = patch;
    }
    decode(data) {
        const isPatch = this.putDecoder.isPatchPayload
            ? this.putDecoder.isPatchPayload(data)
            : (data.optionalField('_isPatch')?.boolean ?? false);
        if (isPatch) {
            return this.patchDecoder.decode(data);
        }
        return this.putDecoder.decode(data);
    }
    isDefaultValue(value) {
        return this.patchDecoder.isDefaultValue ? this.patchDecoder.isDefaultValue(value) : false;
    }
    getDefaultValue() {
        return this.patchDecoder.getDefaultValue ? this.patchDecoder.getDefaultValue() : undefined;
    }
}
//# sourceMappingURL=PatchOrPutDecoder.js.map